module.exports = "images/logo.png";